"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var invariant = require('invariant');
var types_1 = require("./types");
function createInitCoords(manager) {
    return function initCoords(sourceIds, _a) {
        if (sourceIds === void 0) { sourceIds = []; }
        var clientOffset = _a.clientOffset, getSourceClientOffset = _a.getSourceClientOffset;
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        verifyInvariants(sourceIds, monitor, registry);
        var sourceId = getDragSourceId(sourceIds, monitor);
        if (sourceId === null) {
            return;
        }
        var sourceClientOffset = determineSourceClientOffset(sourceId, clientOffset, getSourceClientOffset);
        return {
            type: types_1.INIT_COORDS,
            payload: {
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
            },
        };
    };
}
exports.default = createInitCoords;
function verifyInvariants(sourceIds, monitor, registry) {
    invariant(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    for (var _i = 0, sourceIds_1 = sourceIds; _i < sourceIds_1.length; _i++) {
        var s = sourceIds_1[_i];
        invariant(registry.getSource(s), 'Expected sourceIds to be registered.');
    }
}
function getDragSourceId(sourceIds, monitor) {
    var sourceId = null;
    for (var i = sourceIds.length - 1; i >= 0; i--) {
        if (monitor.canDragSource(sourceIds[i])) {
            sourceId = sourceIds[i];
            break;
        }
    }
    return sourceId;
}
function determineSourceClientOffset(sourceId, clientOffset, getSourceClientOffset) {
    var result = null;
    if (clientOffset) {
        invariant(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
        result = getSourceClientOffset(sourceId);
    }
    return result;
}
